module.exports = __webpack_public_path__ + "img/values-bg.d280523b.png";